import { DashboardType } from '../models/Dashboard'

export const dashboardConfig = {
  [DashboardType.TEAM_EVENT_PERFORMANCE]: {
    table: true,
    line_charts: false,
    bar_charts: false,
    readiness_table: true,
    selectAggregation: false,
    selectChartAggregation: false,
    variable_categories: ['RPE', 'GPS', 'HR', 'RR', 'WELLNESS', 'SCORESHEET'],
    variablesExcluded: ['reason', 'pain', 'FMENSACT', 'FMENSFR'],
    charts: ['TDIST_MMIN', 'HSR_EFF', 'VOL_INT', 'MAXVEL_ALL', 'ACC_DEC', 'ACC_DEC_DIST', 'SPD_ZONE', 'VOL_INT_SCAT', 'MAXHR_AVGHR',
      'TRIMP_MIN', 'HR_ZONE', 'TL_RPE_TTM', 'ENJ_DIST', 'RPE_DIST', 'PAIN', 'SDNN_RMSSD', 'PNN50_NN50',
      'SDNN2_SDNN5', 'SDANN2_SDANN5', 'VEL_RADIAL', 'HSR_RADIAL', 'DIST_ZONE', 'DIST_PER_MIN', 'VEL_ZONE',
      'ACC_ZONE', 'ACC_DIST_ZONE', 'HR_ZONE_IND', 'ENJY_DIST', 'VOL_DIST', 'INTS_DIST',
      'TG_DIST', 'PLAYER_WELLNESS', 'WELL_OVERVIEW', 'MINUTES_PLAYED', 'MATCH_TIMELINE'],
    chartWithoutAggregations: [],
    smallChartExceptions: []
  },
  [DashboardType.TEAM_ADVANCED_PERFORMANCE]: {
    table: true,
    line_charts: true,
    bar_charts: false,
    readiness_table: false,
    selectAggregation: false,
    selectChartAggregation: false,
    variable_categories: ['RPE', 'GPS', 'HR', 'SCORESHEET'],
    variablesExcluded: ['reason', 'pain', 'FMENSACT', 'FMENSFR'],
    charts: ['TDIST_MMIN', 'HSR_EFF', 'VOL_INT', 'MAXVEL_ALL', 'ACC_DEC', 'ACC_DEC_DIST', 'SPD_ZONE', 'VOL_INT_SCAT', 'MAXHR_AVGHR',
      'TRIMP_MIN', 'HR_ZONE', 'TL_RPE_TTM', 'ENJ_DIST', 'RPE_DIST', 'PAIN', 'VEL_RADIAL', 'HSR_RADIAL', 'DIST_ZONE',
      'DIST_PER_MIN', 'VEL_ZONE', 'ACC_ZONE', 'ACC_DIST_ZONE', 'HR_ZONE_IND', 'MINUTES_PLAYED'],
    chartWithoutAggregations: [],
    smallChartExceptions: []
  },
  [DashboardType.TEAM_LOAD]: {
    table: true,
    line_charts: true,
    bar_charts: true,
    readiness_table: false,
    selectAggregation: true,
    selectChartAggregation: true,
    variable_categories: ['RPE', 'GPS', 'HR'],
    variablesExcluded: ['reason', 'pain', 'FMENSACT', 'FMENSFR'],
    charts: ['TDIST_MMIN', 'HSR_EFF', 'VOL_INT', 'MAXVEL_ALL', 'ACC_DEC', 'ACC_DEC_DIST', 'SPD_ZONE', 'VOL_INT_SCAT', 'MAXHR_AVGHR',
      'TRIMP_MIN', 'HR_ZONE', 'TL_RPE_TTM', 'SPRINT_HSR', 'TOTAL_DIST_HSR', 'EXPLOSIVE_HSR_MIN',
      'RPE_TTM_ACUTE', 'RPE_TTM_CHRONIC', 'VEL_RADIAL', 'HSR_RADIAL', 'DIST_ZONE', 'DIST_PER_MIN', 'VEL_ZONE',
      'ACC_ZONE', 'ACC_DIST_ZONE', 'LOAD_OVERVIEW', 'WEEK_CHANGE', 'FRESHNESS', 'TRAINING_LOAD'],
    chartWithoutAggregations: ['RPE_TTM_ACUTE', 'RPE_TTM_CHRONIC', 'LOAD_OVERVIEW', 'WEEK_CHANGE', 'FRESHNESS', 'TRAINING_LOAD'],
    smallChartExceptions: []
  },
  [DashboardType.TEAM_OVERVIEW]: {
    table: true,
    line_charts: true,
    bar_charts: true,
    readiness_table: false,
    selectAggregation: true,
    selectChartAggregation: true,
    variable_categories: ['RPE', 'GPS', 'HR', 'WELLNESS'],
    variablesExcluded: ['reason', 'pain', 'FMENSACT', 'FMENSFR'],
    charts: ['TDIST_MMIN', 'HSR_EFF', 'VOL_INT', 'MAXVEL_ALL', 'ACC_DEC', 'ACC_DEC_DIST', 'SPD_ZONE', 'VOL_INT_SCAT', 'MAXHR_AVGHR',
      'TRIMP_MIN', 'HR_ZONE', 'TL_RPE_TTM', 'PAIN', 'VEL_RADIAL', 'HSR_RADIAL', 'DIST_ZONE', 'DIST_PER_MIN', 'VEL_ZONE',
      'ACC_ZONE', 'ACC_DIST_ZONE', 'HR_ZONE_IND', 'PLAYER_WELLNESS', 'WELL_OVERVIEW', 'SPRINT_HSR', 'TOTAL_DIST_HSR', 'EXPLOSIVE_HSR_MIN',
      'RPE_TTM_ACUTE', 'RPE_TTM_CHRONIC', 'SLQ_SLD', 'MOO_STL', 'GMS', 'LOAD_OVERVIEW', 'WEEK_CHANGE', 'FRESHNESS', 'TRAINING_LOAD',
      'SLQ_SLD_TREND', 'MOO_STL_TREND', 'GMS_TREND'],
    chartWithoutAggregations: ['RPE_TTM_ACUTE', 'RPE_TTM_CHRONIC', 'PLAYER_WELLNESS', 'WELL_OVERVIEW', 'PAIN', 'SLQ_SLD', 'MOO_STL', 'GMS', 'LOAD_OVERVIEW', 'WEEK_CHANGE', 'FRESHNESS', 'TRAINING_LOAD', 'SLQ_SLD_TREND', 'MOO_STL_TREND', 'GMS_TREND'],
    smallChartExceptions: ['SLQ_SLD', 'MOO_STL', 'GMS']
  },
  [DashboardType.PLAYER_EVENTS]: {
    table: true,
    line_charts: true,
    bar_charts: false,
    readiness_table: false,
    selectAggregation: false,
    selectChartAggregation: false,
    variable_categories: ['RPE', 'GPS', 'HR', 'RR'],
    variablesExcluded: ['reason', 'pain', 'FMENSACT', 'FMENSFR'],
    charts: ['VEL_RADIAL', 'HSR_RADIAL', 'DIST_ZONE', 'DIST_PER_MIN', 'VEL_ZONE', 'ACC_ZONE', 'ACC_DIST_ZONE'],
    chartWithoutAggregations: [],
    smallChartExceptions: []
  },
  [DashboardType.PLAYER_PERFORMANCE]: {
    table: false,
    line_charts: false,
    bar_charts: false,
    readiness_table: false,
    selectAggregation: false,
    selectChartAggregation: false,
    variable_categories: ['RPE', 'GPS', 'HR', 'RR', 'WELLNESS'],
    variablesExcluded: ['reason', 'pain', 'FMENSACT', 'FMENSFR'],
    charts: ['VEL_RADIAL', 'HSR_RADIAL', 'DIST_ZONE', 'DIST_PER_MIN', 'VEL_ZONE', 'ACC_ZONE', 'ACC_DIST_ZONE', 'HR_ZONE_IND',
      'RAW_DATA', 'EFFORTS', 'PLAYER_WELLNESS', 'WELL_OVERVIEW'],
    chartWithoutAggregations: [],
    smallChartExceptions: []
  },
  [DashboardType.PLAYER_LOAD]: {
    table: true,
    line_charts: true,
    bar_charts: false,
    readiness_table: false,
    selectAggregation: true,
    selectChartAggregation: false,
    variable_categories: ['RPE', 'GPS', 'HR'],
    variablesExcluded: ['reason', 'pain', 'FMENSACT', 'FMENSFR'],
    charts: ['LOAD_OVERVIEW', 'WEEK_CHANGE', 'FRESHNESS', 'TRAINING_LOAD'],
    chartWithoutAggregations: ['TRAINING_LOAD'],
    smallChartExceptions: []
  },
  [DashboardType.PLAYER_OVERVIEW]: {
    table: true,
    line_charts: true,
    bar_charts: false,
    readiness_table: false,
    selectAggregation: true,
    selectChartAggregation: false,
    variable_categories: ['RPE', 'GPS', 'HR', 'WELLNESS'],
    variablesExcluded: ['reason', 'pain', 'FMENSACT', 'FMENSFR'],
    charts: ['LOAD_OVERVIEW', 'WEEK_CHANGE', 'FRESHNESS', 'TRAINING_LOAD', 'PLAYER_WELLNESS', 'WELL_OVERVIEW', 'PAIN',
      'SLQ_SLD_PLAYER', 'MOO_STL_PLAYER', 'GMS_PLAYER', 'TSA', 'COMPOSITE_DIAG', 'DIAG_TREND'],
    chartWithoutAggregations: ['TRAINING_LOAD', 'PLAYER_WELLNESS', 'WELL_OVERVIEW', 'PAIN', 'SLQ_SLD_PLAYER', 'MOO_STL_PLAYER', 'GMS_PLAYER', 'TSA', 'COMPOSITE_DIAG', 'DIAG_TREND'],
    smallChartExceptions: ['SLQ_SLD_PLAYER', 'MOO_STL_PLAYER', 'GMS_PLAYER', 'COMPOSITE_DIAG', 'DIAG_TREND']
  },
  [DashboardType.COACH_EXERCISE_INSIGHTS]: {
    table: true,
    line_charts: false,
    bar_charts: false,
    readiness_table: false,
    selectAggregation: true,
    selectChartAggregation: false,
    cardAggregation: false,
    variable_categories: ['EXERCISE', 'BALLISTICS', 'BASKETBALL', 'CARDIO', 'ENDURANCE', 'FOOTBALL', 'MOBILITY', 'PLYOMETRICS', 'SPEED', 'STRENGTH', 'SWIMMING'],
    variablesExcluded: [],
    charts: ['COACH_TAG_SUMMARY'],
    chartWithoutAggregations: [],
    smallChartExceptions: []
  },
  [DashboardType.PLAYER_EXERCISE_INSIGHTS]: {
    table: true,
    line_charts: false,
    bar_charts: false,
    readiness_table: false,
    selectAggregation: true,
    selectChartAggregation: false,
    cardAggregation: false,
    variable_categories: ['EXERCISE', 'BALLISTICS', 'BASKETBALL', 'CARDIO', 'ENDURANCE', 'FOOTBALL', 'MOBILITY', 'PLYOMETRICS', 'SPEED', 'STRENGTH', 'SWIMMING'],
    variablesExcluded: [],
    charts: ['PLAYER_TAG_SUMMARY', 'EXERCISE_INSIGHTS_TREND'],
    chartWithoutAggregations: [],
    smallChartExceptions: []
  },
  [DashboardType.COACH_EXERCISE_INSIGHTS_INDIVIDUAL]: {
    table: true,
    line_charts: false,
    bar_charts: false,
    readiness_table: false,
    selectAggregation: true,
    selectChartAggregation: false,
    cardAggregation: false,
    variable_categories: ['EXERCISE', 'BALLISTICS', 'BASKETBALL', 'CARDIO', 'ENDURANCE', 'FOOTBALL', 'MOBILITY', 'PLYOMETRICS', 'SPEED', 'STRENGTH', 'SWIMMING'],
    variablesExcluded: [],
    charts: ['EXERCISE_INSIGHTS_TREND', 'COACH_TAG_SUMMARY'],
    chartWithoutAggregations: [],
    smallChartExceptions: []
  },
  [DashboardType.PLAYER_EXERCISE_INSIGHTS_INDIVIDUAL]: {
    table: true,
    line_charts: false,
    bar_charts: false,
    readiness_table: false,
    selectAggregation: true,
    selectChartAggregation: false,
    cardAggregation: false,
    variable_categories: ['EXERCISE', 'BALLISTICS', 'BASKETBALL', 'CARDIO', 'ENDURANCE', 'FOOTBALL', 'MOBILITY', 'PLYOMETRICS', 'SPEED', 'STRENGTH', 'SWIMMING'],
    variablesExcluded: [],
    charts: ['EXERCISE_INSIGHTS_TREND', 'PLAYER_TAG_SUMMARY'],
    chartWithoutAggregations: [],
    smallChartExceptions: []
  },
  [DashboardType.PERIOD_SUMMARY]: {
    table: true,
    line_charts: false,
    bar_charts: false,
    readiness_table: false,
    selectAggregation: false,
    selectChartAggregation: false,
    variable_categories: ['RPE', 'GPS', 'HR', 'RR', 'WELLNESS'],
    variablesExcluded: ['reason', 'pain', 'FMENSACT', 'FMENSFR'],
    charts: ['TDIST_MMIN', 'HSR_EFF', 'VOL_INT', 'MAXVEL_ALL', 'ACC_DEC', 'ACC_DEC_DIST', 'SPD_ZONE', 'VOL_INT_SCAT', 'MAXHR_AVGHR',
      'TRIMP_MIN', 'HR_ZONE'],
    chartWithoutAggregations: [],
    smallChartExceptions: []
  }
}
